import { render, staticRenderFns } from "./build-avg-stat.vue?vue&type=template&id=e7d916c0&scoped=true&"
import script from "./build-avg-stat.vue?vue&type=script&lang=js&"
export * from "./build-avg-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d916c0",
  null
  
)

export default component.exports